import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { decode_utf8, getSignedIdStatus, getPathName } from '../../../common/utils/utilsFunc';

export const FormCollectiveGroupingAgreementContext = createContext();

export const ACTIONS = {
  SET_CTA_CTO: "SET_CTA_CTO",
  SET_IDCLIENT_AUX:"SET_IDCLIENT_AUX",
  SET_RESPONSE_SERV1: "SET_RESPONSE_SERV1",
  SET_RESPONSE_SERV2: "SET_RESPONSE_SERV2",
  SET_WEB_CONTENT_TERM: "SET_WEB_CONTENT_TERM",
  SET_DETAIL_CLIENT:"SET_DETAIL_CLIENT",
  SET_LIST_OPTIONS:"SET_LIST_OPTIONS",
  SET_FORM: "SET_FORM",
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",

};

const initialState = {
  ctaCto:null,
  idClientAux: null,
  form:null,
  response_serv1:null,
  response_serv2:null,
  webContentTerm: null,
  detailClient: null,
  listOptions:null,
  webContentTextInfo: "",

};

const FormCollectiveGroupingAgreementReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
          ...state,
          detailClient: action.payload,
          };
    }
    case ACTIONS.SET_IDCLIENT_AUX: {
      return {
          ...state,
          idClientAux: action.payload
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TERM: {
      return {
          ...state,
          webContentTerm: action.payload,
          };
    }
    case ACTIONS.SET_CTA_CTO: {
      return {
          ...state,
          ctaCto: action.payload,
          };
    }
    case ACTIONS.SET_RESPONSE_SERV1: {
      return {
          ...state,
          response_serv1: action.payload,
          };
    }
    case ACTIONS.SET_RESPONSE_SERV2: {
      return {
          ...state,
          response_serv2: action.payload,
          };
    }
    case ACTIONS.SET_FORM: {
      return {
          ...state,
          form: action.payload,
          };
    }
    case ACTIONS.SET_LIST_OPTIONS: {
      return {
          ...state,
          listOptions: action.payload,
          };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const FormCollectiveGroupingAgreementContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(FormCollectiveGroupingAgreementReducer, initialState);

  useEffect(() => {
    if (getPathName() === 'formulario-de-convenio-agrupaciones-colectivas') {
      if(decode_utf8(properties.web_content_terms_form_collective_grouping_agreement)){
        LiferayService.getWebContent(properties.base_url_api,decode_utf8(properties.web_content_terms_form_collective_grouping_agreement))
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TERM,
          });
        })
      }
      
      LiferayService.getListTipoInteracciones(properties.base_url_api, properties.type_interactions_form_collective_grouping_agreement)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_LIST_OPTIONS,
        });
      })
      if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
        LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
          });
        })
      }

    }
  }, []);

  useEffect(() => {
    if(state.ctaCto){
        dispatch({
          payload: state.ctaCto,
          type: ACTIONS.SET_IDCLIENT_AUX,
        }); 
        LiferayService.consultarDetalleCuentaContrato(properties.base_url_api,state.ctaCto, properties.url_ws_empresa, properties.codigo_empresa)
        .then((response) =>{
            dispatch({
                payload: response,
                type: ACTIONS.SET_DETAIL_CLIENT,
            });
            dispatch({
              payload: "",
              type: ACTIONS.SET_CTA_CTO,
            }); 
        })
    }
  },[state.ctaCto])

    useEffect(() => {
      if(state.form){
          LiferayService.sendFormGroupCollective(properties.base_url_api,state.form, properties.url_ws_empresa, properties.codigo_empresa,getSignedIdStatus(),decode_utf8(properties.web_content_name_form_collective_grouping_agreement))
          .then((response) =>{
              dispatch({
                  payload: response,
                  type: ACTIONS.SET_RESPONSE_SERV2,
                });
              })
            }
    },[state.form])

  useEffect(() => {
    if (getPathName() === 'formulario-de-convenio-agrupaciones-colectivas') {
          
      if(state.ctaCto){
        LiferayService.consultarDetalleCuentaContrato(properties.base_url_api,state.ctaCto, properties.url_ws_empresa, properties.codigo_empresa)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_SERV1,
          });
        })
      }
       
     
    }
  }, [state.ctaCto]);
  
  return (
    <FormCollectiveGroupingAgreementContext.Provider value={[state, dispatch]}>
      {children}
    </FormCollectiveGroupingAgreementContext.Provider>
  );
};
export default FormCollectiveGroupingAgreementContextProvider;